import { useCallback } from 'react'
import { Contract } from 'web3-eth-contract'

import { getCommonNftMasterPoolUserInfos } from '../../sushi/utils'

// hooks
import { useActiveWeb3React } from '../'

const useNftInfo = (masterContract: Contract, lpTokenAddress: string) => {
  const { account } = useActiveWeb3React()

  const fetchBalance = useCallback(async () => {
    const nftInfo = await getCommonNftMasterPoolUserInfos(masterContract, account)
    return nftInfo
  }, [account, masterContract])
  return fetchBalance
}

export default useNftInfo
